export default [
  {
    path: "/schools",
    name: "mySchools",
    component: () => import("@/views/school/index.vue"),
    meta: {
      title: "My Schools",
      acc: "y95968",
    },
  },
  {
    path: "/my-school/:id",
    name: "mySchool",
    component: () => import("@/views/school/view.vue"),
    meta: {
      title: "My School",
      acc: "y65627",
    },
  },
  {
    path: "/im0zxRO/:id?",
    name: "status-report",
    component: () => import("@/components/status-report.vue"),
    meta: {
      title: "STATUS REPORT",
    },
  },
];
